export default "__VITE_ASSET__bd853cce__"